import React from "react";
import { Grid } from "@material-ui/core";
import { MaterialIcon } from "@loanbossinc/component-library";

import { Row } from "../styles";

import {
  FieldIconWrapper,
  FieldLeftContentWrapper,
  FieldNameTypeWrapper,
  FieldNameWrapper,
  FieldRightContentWrapper,
  FieldWrapper,
  RemoveWrapper,
  RightAlignedInputNumber
} from "./calculatedFieldStyles";
import { OperationsBar } from "./operationsBar";

export const HardCodedCalculationField = props => {
  const { calculation, idx, numberOfCalculations, onRemoveCalculation, onSetOperation, onValueChange, rowProps } = props;

  return (
    <div key={calculation.id}>
      <Row {...rowProps}>
        <Grid container>
          <FieldWrapper>
            <FieldLeftContentWrapper>
              <FieldIconWrapper>
                <MaterialIcon iconName="code" style={{ color: "#0F9AD6" }} />
              </FieldIconWrapper>
              <FieldNameTypeWrapper>
                <FieldNameWrapper>Manual input value</FieldNameWrapper>
                <RemoveWrapper onClick={() => onRemoveCalculation(calculation)}>Remove</RemoveWrapper>
              </FieldNameTypeWrapper>
            </FieldLeftContentWrapper>
            <FieldRightContentWrapper>
              <RightAlignedInputNumber
                variant="filled"
                id="field-value"
                name="field-value"
                label="Value"
                fullWidth
                decimals={3}
                onChange={event => onValueChange(event, calculation)}
                value={calculation.formattedValue}
              />
            </FieldRightContentWrapper>
          </FieldWrapper>
        </Grid>
      </Row>
      {idx + 1 !== numberOfCalculations ? <OperationsBar calculation={calculation} onSetOperation={onSetOperation} /> : null}
    </div>
  );
};

export default HardCodedCalculationField;
